import template from './permissions.html';
import controller from './permissions.controller';
import './permissions.scss';

let PermissionsComponent = {
  bindings: {},
  template,
  controller
};

export default PermissionsComponent;



// WEBPACK FOOTER //
// ./src/app/pages/permissions/permissions.component.js